export default {
    outbound_proxy_url: '', // optional
    enable_rtcweb_breaker: false, // optional,
    sip_headers: [ // optional
        { name: 'User-Agent', value: 'IM-client/OMA1.0 sipML5-v1.0.0.0' },
        { name: 'Organization', value: 'bspbv' }
    ],
    api: {
        baseUrl: 'https://voip-api.brandstofpas.app/',
        grant_type: 'password',
        client_id: '0197213b-da7a-70e4-a7d1-c9247a75b685',
        secret_key: 'rZAzOFlAaDZxiIuMMJ3wLA822jdPANY3vNQTtwfe',
        expired_in: 10 * 3600, // Seconds
        assets_url: 'https://voip-api.brandstofpas.app/assets'
    },
    storage: {
        key: 'bspbv'
    }
}
